module.exports = __webpack_public_path__ + "static/media/sanecum-logo-white.02166355.svg";